import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { TeacherStudioListItem } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const retrieveTeacherStudio = createAsyncThunk<TeacherStudioListItem, string, { extra: Partial<Dependencies> }>(
  "teacher/studio/retrieve",
  async (id, { extra: { teacherRepository } }) => {
    return teacherRepository!.getStudioById(id);
  },
);

export const resetRetrieveTeacherStudio = createAction("teacher/studio/resetRetrieve");
